import { useState, useEffect } from "react";
import { lightTemperatures } from "settings";
import s from "../Panel/Panel.module.css";

const LightPanel = ({ submit }) => {
    const [mainIntensity, setMainIntensity] = useState(0.25);
    const [mainColor, setMainColor] = useState(1);
    const [wallIntensity, setWallIntensity] = useState(1);
    const [wallColor, setWallColor] = useState(1);
    // const [numberSources, setNumberSources] = useState(1);
    // const [sunIntensity, setSunIntensity] = useState(0.1);
    // const [sunPosition, setSunPosition] = useState(4);
    const [needUpdate, setNeedUpdate] = useState(false);

    useEffect(() => {
        if (needUpdate) {
            submit({
                mainIntensity,
                mainColor: lightTemperatures[mainColor],
                wallIntensity,
                wallColor: lightTemperatures[wallColor],
                // numberSources,
                // sunIntensity,
                // sunPosition,
            });
            setNeedUpdate(false);
        }
    }, [
        mainIntensity,
        mainColor,
        wallIntensity,
        wallColor,
        // numberSources,
        needUpdate,
        submit,
    ]);

    const changeMainLight = (e) => {
        setMainIntensity(Number(e.target.value));
        setNeedUpdate(true);
    };

    const changeWallLight = (e) => {
        setWallIntensity(Number(e.target.value));
        setNeedUpdate(true);
    };

    const changeMainColor = (e) => {
        setMainColor(Number(e.target.value));
        setNeedUpdate(true);
    };

    const changeWallColor = (e) => {
        setWallColor(Number(e.target.value));
        setNeedUpdate(true);
    };

    // const changeSources = (e) => {
    //     setNumberSources(Number(e.target.value));
    //     setNeedUpdate(true);
    // };

    // const changeSunIntensity = (e) => {
    //     setSunIntensity(Number(e.target.value));
    //     setNeedUpdate(true);
    // };

    // const changeSunHeight = (e) => {
    //     setSunPosition(Number(e.target.value));
    //     setNeedUpdate(true);
    // };

    return (
        <>
            {/* <div className={s.prop}>
                <p>Number of ceiling light sources that give shade</p>
                <input
                    className={s.count}
                    type="range"
                    min={1}
                    max={4}
                    step={1}
                    value={numberSources}
                    onChange={changeSources}
                />
            </div> */}

            <div className={s.prop}>
                <p>Ceiling lights intensity</p>
                <input
                    className={s.count}
                    type="range"
                    min={0}
                    max={1}
                    step={0.01}
                    value={mainIntensity}
                    onChange={changeMainLight}
                />
            </div>

            <div className={s.prop}>
                <p>Ceiling lights temperature</p>
                <div className={s.temperature}></div>
                <input
                    className={s.count2}
                    type="range"
                    min={0}
                    max={lightTemperatures.length - 1}
                    value={mainColor}
                    onChange={changeMainColor}
                />
            </div>

            <div className={s.prop}>
                <p>Wall lights intensity</p>
                <input
                    className={s.count}
                    type="range"
                    min={0}
                    max={2.5}
                    step={0.01}
                    value={wallIntensity}
                    onChange={changeWallLight}
                />
            </div>

            <div className={s.prop}>
                <p>Wall lights temperature</p>
                <div className={s.temperature}></div>
                <input
                    className={s.count2}
                    type="range"
                    min={0}
                    max={lightTemperatures.length - 1}
                    value={wallColor}
                    onChange={changeWallColor}
                />
            </div>

            {/* <div className={s.prop}>
                <p>Sun brightness</p>
                <input
                    className={s.count}
                    type="range"
                    min={0}
                    max={2}
                    step={0.01}
                    value={sunIntensity}
                    onChange={changeSunIntensity}
                />
            </div>

            <div className={s.prop}>
                <p>Sun height</p>
                <input
                    className={s.count}
                    type="range"
                    min={0}
                    max={20}
                    value={sunPosition}
                    onChange={changeSunHeight}
                />
            </div> */}
        </>
    );
};

export default LightPanel;
